/* smartfit-events.js  —  finale Version ---------------------------------- */

/* 1) Varianten-Daten einlesen (unverändert) */
window.smartfitVariants = window.smartfitVariants ||
  JSON.parse(document.querySelector('[data-smartfit-variants]').textContent);

/* 2) Callback für Smartfit-Auswahl */
window.selectSuggestedSize = ({ detail }) => {
  const barcode = String(detail.code);
  const variant = window.smartfitVariants.find(v => v.barcode === barcode);
  if (!variant) return;

  /* 2-a  Hidden-Inputs aller Produktformulare */
  document.querySelectorAll('form[action*="/cart"] input[name="id"]')
          .forEach(inp => inp.value = variant.id);

  /* 2-b  data-variant-id an CTA-Buttons */
  document.querySelectorAll('[data-variant-id]')
          .forEach(btn => btn.dataset.variantId = variant.id);

  /* 2-c  URL-Parameter für Teilbarkeit */
  if (history.replaceState) {
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url);
  }

  /* 2-d  Ggf. Theme-eigene Variant-API ansprechen */
  if (window.ProductVariantSelect?.setVariant) {
    window.ProductVariantSelect.setVariant(variant.id);
  }

  /* 2-e  Zentrales Theme-Event feuern */
  document.dispatchEvent(
    new CustomEvent('on:variant:change', { bubbles: true, detail: { variant } })
  );

  /* 2-f  Widgets (sf-sizing / sf-geometry) kommen gleich via Listener
          — siehe Abschnitt 3 — auf den neuesten Stand */

  /* 2-g  Sichtbares custom-select synchronisieren
          (falls es nicht durch Theme-Event passiert)        */
  const li = document.querySelector(
    `.custom-select__option[data-code="${CSS.escape(barcode)}"]`
  );
  if (li) {
    /* Variante intern auswählen, falls Theme Komponente exposet */
    const cs = li.closest('custom-select');
    if (cs?.selectOption) {               // manche Themes bieten diese Methode an
      cs.selectOption(li);
    } else {
      /* Fallback: aria und Button-Label manuell */
      cs?.querySelectorAll('.custom-select__option')
        .forEach(el => el.removeAttribute('aria-selected'));
      li.setAttribute('aria-selected', 'true');
      const btnLabel = cs?.querySelector('.custom-select__btn span');
      if (btnLabel) btnLabel.textContent = li.dataset.value || variant.option1;
    }
  }
};

/* 3) Widget-Attribute bei Variant-Wechsel (unverändert) */
document.addEventListener('on:variant:change', ({ detail }) => {
  const v = detail.variant || detail;
  if (!v) return;

  ['sf-sizing', 'sf-geometry'].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('variant-id', v.id);
    el.setAttribute('global-id',  v.barcode);
    const img = v.featured_image?.src || v.image;
    if (img) el.setAttribute('image', img);
  });
});